module.exports = __webpack_public_path__ + "_/_/_/node_modules/@reverbdotcom/discovery-ui/images/payment-icons/affirm-f49c32ce30fb4d63f7be7e061a30037f.svg";


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/images/payment-icons/affirm.svg
// module id = e4qL
// module chunks = 21 23